import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosService from "lib/axios";

export const fetchJobAction = createAsyncThunk<undefined, { page?: number, limit?: number, search?: string, field?: string }>(
    "list/jobs",
    async (arg, thinkAPI) => {
        const { data, status } = await axiosService.get("jobs", { params: arg });

        if (data.count) {
            window.localStorage.setItem("totalCountJobs", data.count);
        }

        if (status !== 200) return thinkAPI.rejectWithValue(new Error(data.message || "Something is wrong here"));
        return thinkAPI.fulfillWithValue({ ...data, arg });
    },
);